import PaymentsIcon from '@mui/icons-material/Payments';
import { Button, Dialog, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { Contract } from '../types';
import { PaymentCreate } from './PaymentCreate';

export const AddPaymentButton = () => {
  const record = useRecordContext<Contract>();
  const translate = useTranslate();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Stack direction="row" spacing={2} sx={{ paddingX: 2 }}>
        <Button
          startIcon={<PaymentsIcon />}
          onClick={handleClickOpen}
          aria-label={translate('resources.payments.buttonAdd')}
        >
          {translate('resources.payments.buttonAdd')}
        </Button>
      </Stack>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{translate('resources.payments.buttonAdd')}</DialogTitle>
        <DialogContent>
          <PaymentCreate setOpen={setOpen} contract={record} />
        </DialogContent>
      </Dialog>
    </>
  );
};
